//@flow

import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import classnames from 'classnames';
import CheckmarkCircleIcon from 'dibs-vg/dist/react/checkmark-circle';
import {
    TPN_TIER_MEMBER,
    TPN_TIER_BRONZE,
    TPN_TIER_SILVER,
    TPN_TIER_GOLD,
    TPN_TIER_PLATINUM,
} from 'dibs-trade-rewards-progress/exports/tpnStatusCodes';

import { getBenefits } from './getBenefits';

import styles from './TierDetails.scss';

import type { Node } from 'react';

type Props = {|
    code: ?string,
    displayName: ?Node,
    maxAnnualSpend: number,
    minimumAnnualSpend: number,
|};

//export for testing. must be a class to have refs
export function TierDetails(props: Props) {
    const { code, displayName, maxAnnualSpend, minimumAnnualSpend } = props;
    const benefits = getBenefits(code);

    return (
        <div
            key={`tier-details-${code || ''}`}
            className={classnames(styles.tierDetails, {
                [styles.colorMember]: code === TPN_TIER_MEMBER,
                [styles.colorBronze]: code === TPN_TIER_BRONZE,
                [styles.colorSilver]: code === TPN_TIER_SILVER,
                [styles.colorGold]: code === TPN_TIER_GOLD,
                [styles.colorPlatinum]: code === TPN_TIER_PLATINUM,
            })}
        >
            <div className={styles.tierDetailsHeader}>{displayName}</div>
            <div className={styles.tierPointsRange}>
                {code === TPN_TIER_PLATINUM ? (
                    <FormattedMessage
                        id="abt.loyaltyModules.BenefitsChartMobile.platinumInfoSpendRange"
                        defaultMessage="{minTpnPoints} + Points"
                        values={{
                            minTpnPoints: <FormattedNumber value={minimumAnnualSpend} />,
                        }}
                    />
                ) : (
                    <FormattedMessage
                        id="abt.loyaltyModules.BenefitsChartMobile.tpnInfoSpendRange"
                        defaultMessage="{minTpnPoints} - {maxTpnPoints} Points"
                        values={{
                            minTpnPoints: <FormattedNumber value={minimumAnnualSpend} />,
                            maxTpnPoints: <FormattedNumber value={maxAnnualSpend} />,
                        }}
                    />
                )}
            </div>
            <div className={styles.benefitsListContainer}>
                <div className={styles.benefitsList}>
                    {benefits.map(benefit => (
                        <div className={styles.benefitItem} key={benefit.name}>
                            <CheckmarkCircleIcon className={styles.checkIcon} />
                            {benefit.copy}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
